<ng-container>
    <p-contextMenu #taskContextMenu [model]="contextMenuItems" [autoZIndex]="true" appendTo="body" (onShow)="populateContextMenu()">
    </p-contextMenu >
<div class="p-grid">
    <div class="p-col-12">
        <div class="card" [class.p-p-0]="isSidebar">
            <p-table #taskTable [columns]="tasksCols" [value]="filteredEvents" [paginator]="true" [paginator]="true"
            [rows]="15" selectionMode="single" dataKey="id" (onRowSelect)="onRowTaskSelect($event, true)"
            (onRowUnselect)="selectedTask = null" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [showCurrentPageReport]="true" [rowsPerPageOptions]="tableShowMore" styleClass="p-datatable-gridlines"
            [contextMenu]="taskContextMenu"
            [(contextMenuSelection)]="selectedTask" [tableStyle]="{'min-width': '1050px'}"
            [(selection)]="selectedTask" [class.captionNoHeader]="isSidebar">
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-ai-center">
                        <!-- Task title -->
                        <span [class.p-ml-3]="isSidebar">Tasks</span>

                        <div class="p-ml-auto p-d-flex">
                            <p-dropdown [options]="filterDataByTime" [(ngModel)]="selectedDateFilter" (onChange)="onFilterChange($event)"
                                showClear="true" (onClear)="resetFilter($event)" optionLabel="label" styleClass="event-filter" [style]="{ width: '150px' }" appendTo="body">
                            </p-dropdown>

                            <div *ngIf="selectedDateFilter?.code === 'custom'" class="p-ml-2 p-d-flex gap-2">
                                <p-calendar [(ngModel)]="dateFrom" [showIcon]="true" placeholder="From Date" (onSelect)="onCustomDateChange()"
                                    [maxDate]="dateTo || undefined" [style]="{ width: '150px' }" placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" appendTo="body">
                                </p-calendar>

                                <p-calendar [(ngModel)]="dateTo" [showIcon]="true" placeholder="To Date" (onSelect)="onCustomDateChange()"
                                    [minDate]="dateFrom || undefined" [style]="{ width: '150px' }" placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" appendTo="body">
                                </p-calendar>
                            </div>
                            <!-- Refresh Icon -->
                            <span class="btnBarsKanban" pTooltip="Refresh List" tooltipPosition="top" (click)="refreshData()">
                                <i class="pi pi-refresh  p-cursor-pointer"></i>
                            </span>

                            <!-- Add Task Plus Icon -->
                            <div class="btnBarsKanban" pTooltip="Add Task" tooltipPosition="top" *ngIf="selectedAccount?.statusId == 1" (click)="showAddTask()">
                                <i class="pi pi-plus p-cursor-pointer"></i>
                            </div>
                        </div>
                    </div>
                </ng-template>

                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: auto;" [pSortableColumn]="'taskId'">
                            Task ID
                            <p-sortIcon field="taskId"></p-sortIcon>
                        </th>
                        <th style="width: auto;" [pSortableColumn]="'task.name'">
                            Task Title
                            <p-sortIcon field="task.name"></p-sortIcon>
                        </th>
                        <th style="width: auto;" [pSortableColumn]="'task.description'">
                            Task Details
                            <p-sortIcon field="task.description"></p-sortIcon>
                        </th>
                        <th style="width: auto;" [pSortableColumn]="'task.startDateTime'">
                            Start Date
                            <p-sortIcon field="task.startDateTime"></p-sortIcon>
                        </th>
                        <th style="width: auto;" [pSortableColumn]="'task.endDateTime'">
                            Due Date
                            <p-sortIcon field="task.endDateTime"></p-sortIcon>
                        </th>
                        <th style="width: auto;" [pSortableColumn]="'task.assignedTo'">
                            Assign To
                            <p-sortIcon field="task.assignedTo"></p-sortIcon>
                        </th>
                        <th style="width: auto;" [pSortableColumn]="'task.reassignTo'">
                            Re-Assign to
                            <p-sortIcon field="task.reassignTo"></p-sortIcon>
                        </th>
                        <th style="width: auto;" [pSortableColumn]="'task.status'">
                            Status
                            <p-sortIcon field="task.status"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-taskData  let-columns="columns">
                    <tr [pSelectableRow]="taskData" [pContextMenuRow]="taskData">
                        <td class="action">
                            <div class="p-text-left">
                                <span class="pi pi-users" style="color: var(--primary-color);"
                                      *ngIf="taskData?.task?.taskTypeId == TaskType.Group"
                                      pTooltip="Multiple Task" tooltipPosition="left"></span>
                                <span class="pi pi-user" style="color: var(--primary-color);"
                                      *ngIf="taskData?.task?.taskTypeId == TaskType.Individual"
                                      pTooltip="Single Task" tooltipPosition="left"></span>
                                 {{ taskData?.taskId}}
                            </div>
                        </td>
                        <td style="word-break: break-all;">
                            <span *ngIf="taskData?.task?.name?.length > 0" pTooltip="{{taskData?.task?.name}}" tooltipPosition="top">
                                {{ taskData?.task?.name?.length > 10 ? (taskData?.task?.name | slice : 0 : 10) + "..." : taskData?.task?.name }}
                            </span>
                        </td>
                        <td class="action">
                          <span  pTooltip="{{taskData?.task?.description | removeHtmlTags}}" tooltipPosition="top" [innerHTML]="taskData?.task?.description  | removeHtmlTags | shorten:30"></span>
                          <span *ngIf="taskData.task?.attachmentStatus"
                          class="pi pi-paperclip"
                          pTooltip="Attachments"
                          tooltipPosition="top"
                          style=" color: var(--primary-color);"></span>
                        </td>
                        <td>
                            <span pTooltip="{{ taskData?.task?.startDateTime | localDate:'dateTime'}}" tooltipPosition="top">
                                {{ taskData?.task?.startDateTime | localDate:'dateTime'}}
                              </span>
                        </td>

                        <!-- End Date -->
                        <td>
                            <span pTooltip="{{ taskData?.task?.endDateTime | localDate:'dateTime'}}" tooltipPosition="top">
                                {{ taskData?.task?.endDateTime | localDate:'dateTime'}}
                            </span>

                        </td>
                        <td class="no-padding">
                            <p-avatarGroup styleClass="mb-3">
                                <p-avatar
                                label="{{ taskData?.task.assignedUser[getAssignedUserIndex(taskData?.task)]?.assignedUser }}" tooltipPosition="top" pTooltip="{{ taskData?.task.assignedTo}}"
                                shape="circle" class="p-mr-1"
                                [style]="{ 'background-color': 'var(--primary-color)', color: '#ffffff' }" />
                                @if(taskData?.task.assignedUser?.length > 1){
                                    <p-avatar
                                    label="+{{taskData?.task.assignedUser?.length -1}}"
                                    shape="circle"
                                    [style]="{ 'background-color': 'var(--primary-color)', color: '#ffffff', 'margin-left': '-7px'}"
                                    pTooltip="{{ taskData?.task.assignedTo }}" tooltipPosition="top" />
                                }
                            </p-avatarGroup>

                        </td>
                        <td class="no-padding">
                            <p-avatarGroup styleClass="mb-3" *ngIf="taskData?.task?.reassignUser?.length>0">
                                <p-avatar
                                label="{{taskData?.task?.reassignUser[getReassignedUserIndex(taskData?.task)]?.assignedUser}}" tooltipPosition="top"
                                pTooltip="{{ taskData?.task?.reassignTo }}"
                                shape="circle" class="p-mr-1" class="custom-circle"
                                [style]="{ 'background-color': 'var(--primary-color)', color: '#ffffff' }" />
                                @if(taskData?.task?.reassignUser?.length > 1){
                                    <p-avatar
                                    label="+{{taskData?.task?.reassignUser?.length - 1}}"
                                    shape="circle" class="custom-circle"
                                    [style]="{ 'background-color': 'var(--primary-color)', color: '#ffffff', 'margin-left': '-7px'}"
                                    pTooltip="{{ taskData?.task?.reassignTo }}" tooltipPosition="top" />
                                }
                            </p-avatarGroup>
                        </td>
                        <td class="action">
                            <p-tag
                            pTooltip="{{taskData?.task?.status}}" tooltipPosition="top"
                            [value]="taskData?.task?.status"
                            [style]="{'background-color': taskData?.task?.statusColor}">
                            </p-tag>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="20">
                            {{ noTaskFindOrLoadingText }}
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
</ng-container>

<app-shared-create-task *ngIf="displayAddTask"
    [headerTitle]="headerTitle"
    [displayAddEditDialog]="displayAddTask"
    [taskFromModule]="true"
    [isAddTask]="isAddTask"
    [moduleId]="objectTypeId"
    [isCopyTask]="isCopyTask"
    [selectedObject]="selectedAccount"
    [selectedTaskId]="selectedTask"
    (cancelClicked)="cancelClicked($event)"
    (onCreateComplete)="reloadTaskiList()">
</app-shared-create-task>
